// SpecialSession/SpecialSessionsTabContent.tsx
import { SpecialSessionAnswersTab } from './SpecialSessionAnswersTab';
import { useRegistrationMemberOptions } from './useRegistrationMemberOptions';

export interface SpecialSessionsTabContentProps {
  registrationID: number;
  registrationSessionID: number;
}

/** Campus users only read the answers: the admin "Fill Form" view is not offered. */
export default function SpecialSessionsTabContent({ registrationID, registrationSessionID }: SpecialSessionsTabContentProps) {
  const memberOptions = useRegistrationMemberOptions(registrationID);
  return <SpecialSessionAnswersTab registrationSessionID={registrationSessionID} memberOptions={memberOptions} />;
}
